import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EventGroundTransportTravelLegForm } from "Bands/components";
import { createTravelLeg, dataMetaSelector } from "Bands/state";
import { BAND_ACTIONS, IEventGroundTransportTravelLegParams, TravelLegType } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { copy } from "shared/assets";
import { Car } from "shared/assets/icons";
import { Modal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { API_ENDPOINTS } from "shared/constants";
import { IAPIState, IFormButtons, IStatus } from "shared/types";

const createCopy = copy.travelBlock.groundTransport.create;

interface Props {
  blockId: string;
  handleClose: () => void;
}

export const CreateGroundTransportTravelLegModal: React.FC<Props> = ({ blockId, handleClose }) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.createTravelLeg));

  useClearActionMetaOnUnMount(BAND_ACTIONS.createTravelLeg);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: createCopy.messages.success,
        })
      );

      handleClose();
    }
  }, [apiMeta?.status, dispatch, handleClose]);

  const handleAdd = (data: IEventGroundTransportTravelLegParams) => {
    const cleanData: IEventGroundTransportTravelLegParams = {
      travelBlock: API_ENDPOINTS.EVENT_TRAVEL_BLOCK(blockId),
      ...data,
    };

    dispatch(
      createTravelLeg({
        data: cleanData,
        travelLegType: TravelLegType.groundTransport,
      })
    );
  };

  const buttons: IFormButtons = useMemo(
    () => ({
      primary: {
        children: createCopy.buttons.create,
      },
      secondary: {
        onClick: handleClose,
      },
    }),
    [handleClose]
  );

  return (
    <Modal title={createCopy.title} icon={Car}>
      <EventGroundTransportTravelLegForm
        buttons={buttons}
        handleSubmit={handleAdd}
        isSubmitting={apiMeta?.status === IAPIState.pending}
        apiError={apiMeta?.error}
        error={!!apiMeta?.error}
      />
    </Modal>
  );
};
